/* eslint-disable new-cap */
import {LitElement, html, nothing} from 'lit';
import styles from './waitlist-signup.component.scss?as=stylesheet';
import successSVG from './success-check.svg';
import {defineCustomElement} from 'extensions/utils';

class WaitlistSignup extends LitElement {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			formSubmitted: {
				type: Boolean
			},
			formSubmitting: {
				type: Boolean
			},
			message: {
				type: String
			},
			productCode: {
				attribute: 'product-code',
				type: String
			},
			showForm: {
				type: Boolean
			},
			stockLevel: {
				attribute: 'stock-level',
				type: String
			}
		};
	}

	constructor () {
		super();

		this.productCode = '';
		this.stockLevel = '';

		this.formSubmitted = 0;
		this.formSubmitting = 0;
		this.showForm = 0;
		this.message = '';

		this.publicKey = 'QKiGMe';
		this.addToCart = document.querySelector('#js-add-to-cart');
	}

	render () {
		this.showHideWaitlistSection();

		if (this.stockLevel !== 'out') {
			return nothing;
		}

		return html`
			<div class="waitlist-section">
				${this.renderNotifyButton()}
				${this.renderForm()}
				${this.renderMessage()}
			</div>
		`;
	}

	renderNotifyButton () {
		if (this.showForm || this.formSubmitted) {
			return nothing;
		}

		return html`
			<button type="button" class="notify-me-button" @click="${this.handleClick}">Notify Me</button>
		`;
	}

	renderForm () {
		if (!this.showForm || this.formSubmitted) {
			return nothing;
		}

		return html`
			<form method="POST" action="https://a.klaviyo.com/onsite/components/back-in-stock/subscribe" @submit="${this.handleSubmit}" class="waitlist-form">
				<input name="email" type="email" class="email-input" placeholder="Enter your email here" required />
				<button type="submit" class="submit-button" ?disabled="${this.formSubmitting}">${this.formSubmitting ? 'Loading...' : 'Get Notified'}</button>
			</form>
		`;
	}

	renderMessage () {
		if (!this.formSubmitted) {
			return nothing;
		}

		return html`
			<div class="message">
				${this.message}
			</div>
		`;
	}

	showHideWaitlistSection () {
		if (this.stockLevel === 'out') {
			this.addToCart?.classList?.add('hide');
		} else {
			this.addToCart?.classList?.remove('hide');
		}
	}

	handleClick () {
		this.showForm = 1;

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'waitlist_notify_me'
		});
	}

	resetFields () {
		this.formSubmitted = 0;
		this.formSubmitting = 0;
		this.showForm = 0;
		this.message = '';
	}

	async handleSubmit (e) {
		e.preventDefault();
		if (this.formSubmitting === 1) {
			return;
		}

		this.formSubmitting = 1;
		const form = e.target;

		const response = await this.sendSignup(form);

		this.formSubmitting = 0;
		this.formSubmitted = 1;

		if (response.success) {
			this.success();
			return;
		}

		this.error(response);
	}

	async sendSignup (form) {
		const data = new FormData(form);
		data.append('a', this.publicKey);
		data.append('variant', this.productCode);
		data.append('platform', 'api');

		const request = await fetch(form.action, {
			body: data,
			method: 'POST'
		});

		if (!request.ok) {
			return 0;
		}

		const response = await request.json();

		return response;
	}

	success () {
		this.message = html`
			<img src="${successSVG}" alt="" class="message-icon"> Email Confirmed!
		`;

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'waitlist_signup'
		});
	}

	error (response) {
		this.message = response.errors ? response.errors.join(', ') : response.message;
	}

}

defineCustomElement('x-waitlist-signup', WaitlistSignup);
